import {createFileRoute, notFound} from '@tanstack/react-router'
import {useTranslations} from 'use-intl'
import {Suspense} from 'react'
import getLegalPageContent from '~/client/fn/legalPageContent'
import Breadcrumbs from '~/components/common/Breadcrumbs'
import LegalText from '~/components/legal/Text'
import seo from '~/utils/seo'

export const Route = createFileRoute('/$lang/_layout/_legal/legal')({
    component: RouteComponent,
    loader: async ({context}) => {
        const data = await getLegalPageContent({
            data: {type: 'legal', locale: context.locale},
        })

        if (!data) {
            throw notFound()
        }

        return data
    },
    head: ({loaderData}) => {
        return {
            meta: [
                ...seo({
                    title: loaderData?.title,
                }),
                {
                    name: 'robots',
                    content: 'noindex',
                },
            ],
        }
    },
})

function RouteComponent() {
    const t = useTranslations('legal')
    const {title, content} = Route.useLoaderData()

    return (
        <div className="px-4 py-6 mx-auto max-w-screen-xl lg:py-12 sm:px-6">
            <Breadcrumbs
                className="mb-2 md:mb-6"
                items={[
                    {name: t('breadcrumbs.home'), to: '/'},
                    {name: title, to: '.'},
                ]}
            />
            <h1 className="text-2xl font-medium mb-6">{title}</h1>
            <Suspense>
                <LegalText value={content} />
            </Suspense>
        </div>
    )
}
